<template>
	<div class="work-group">
		<div class="view-title">
			<translate>Work Group</translate>
		</div>
		<div class="content">
			<div class="header-nav">
				<div class="clearfix pull-right" v-if="mode">
					<el-select v-model="searchCondition" :placeholder="attrText.select" class="search-select" @change="clearSearchInput">
						<el-option :label="attrText.name" value="q_name"></el-option>
						<el-option label="IP" value="q_ip"></el-option>
					</el-select>
					<div class="search-input">
						<el-input v-model.trim="searchKey" :disabled="!searchCondition" @keyup.enter.native="onSearch(1)"></el-input>
					</div>
					<el-button @click.stop="onSearch(1)">
						<translate>Search</translate>
					</el-button>
					<!--<div class="change-view">-->
					<!--<i class="fa fa-th-large active" aria-hidden="true"></i>-->
					<!--<i class="fa fa-th-list" aria-hidden="true"></i>-->
					<!--</div>-->
				</div>

				<el-button :class="{ 'el-button--primary': mode, 'el-button--default': !mode }" @click.stop="onChangeMode(1)">
					<translate>All Work Group</translate>
				</el-button>
				<el-button :class="{ 'el-button--primary': !mode, 'el-button--default': mode }" @click.stop="onChangeMode(0)" :disabled="!favourites || !favourites.length">
					<translate>Star Work Group</translate>
				</el-button>
			</div>

			<div class="content-list">
				<div class="favourites-workgroup" v-if="favourites && favourites.length">
					<el-table :show-header="false" :data="favourites" style="width: 100%" @row-click="rowClick" v-loading="loading">
						<el-table-column>
							<template scope="scope">
								{{ scope.row.name }}
							</template>
						</el-table-column>
						<el-table-column prop="desc"> </el-table-column>
						<el-table-column width="120" class-name="text-right">
							<template scope="scope">
								{{ getTranTest(scope.row.resource_count) }}
							</template>
						</el-table-column>
						<el-table-column width="100" class-name="text-right">
							<template scope="scope">
								<div class="icon-box">
									<i class="el-icon-star-on" @click.stop="setFavourite(scope.row, 0)"></i>
									<a class="export-excel-icon" @click.stop="exportExcel(scope.row)">
										<i class="fa fa-external-link" aria-hidden="true"></i>
									</a>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>

				<div class="list-workgroup" v-if="mode">
					<el-table :show-header="false" :data="workgroup.objects" style="width: 100%" @row-click="rowClick" v-loading="loading">
						<el-table-column>
							<template scope="scope">
								{{ scope.row.name }}
							</template>
						</el-table-column>
						<el-table-column prop="desc"> </el-table-column>
						<el-table-column width="120" class-name="text-right">
							<template scope="scope">
								{{ getTranTest(scope.row.resource_count) }}
							</template>
						</el-table-column>
						<el-table-column width="100" class-name="text-right">
							<template scope="scope">
								<div class="icon-box">
									<i class="el-icon-star-on" :class="{ active: scope.row.favourite, default: !scope.row.favourite }" @click.stop="setFavourite(scope.row, !scope.row.favourite)"></i>
									<a class="export-excel-icon" @click.stop="exportExcel(scope.row)">
										<i class="fa fa-external-link" aria-hidden="true"></i>
									</a>
								</div>
							</template>
						</el-table-column>
					</el-table>
					<div class="text-right" v-if="workgroup.total > 9">
						<el-pagination @current-change="onCurrentChange" :page-size="pageSize" :current-page.sync="currentPage" layout="total, prev, pager, next" :total="workgroup.total"> </el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import STORE_CONST from '../../store/consts'
import { Utils, baseUrl } from '../../config'

export default {
	name: 'WorkGroup',
	data() {
		return {
			searchData: this.$route.query,
			pageSize: Utils.config.pageSize,
			mode: 1,
			searchCondition: 'q_name',
			searchKey: '',
			favourites: [],
			workgroup: {},
			currentPage: 1,
			loading: true,
		}
	},
	computed: {
		attrText() {
			return this.getTranslateText()
		},
	},
	mounted() {
		this.getList(1, this.$route.query)
		this.getFavourites()
		this.setSearchData()
	},
	methods: {
		getTranTest(clusters) {
			let translated = this.$ngettext('%{ n } resource', '%{ n } resources', clusters)
			let interpolated = this.$gettextInterpolate(translated, { n: clusters })
			return interpolated
		},
		getTranslateText() {
			return {
				searchKey: this.$gettext('please input search key'),
				select: this.$gettext('select'),
				name: this.$gettext('Name'),
			}
		},
		rowClick(row, event, column) {
			const searchData = {}
			if (this.searchKey !== '' && this.searchCondition) {
				searchData[this.searchCondition] = this.searchKey
			}
			this.$router.push({ name: 'workgroupdetail', params: { id: row.id }, query: Object.assign({ type: this.$route.type || 'ecs' }, this.$route.query) })
		},
		clearSearchInput() {
			this.searchKey = ''
		},
		setSearchData() {
			const _query = this.$route.query
			if (Object.keys(_query).length) {
				for (let k in _query) {
					if (k == 'q_ip' || k == 'q_name') {
						this.searchCondition = k
						setTimeout(() => {
							this.searchKey = _query[k]
						}, 200)
					}
				}
			} else {
				this.searchKey = ''
				this.searchCondition = 'q_name'
			}
		},
		onSearch(pageIndex) {
			const params = {}
			if (this.searchKey !== '' && this.searchCondition) {
				params[this.searchCondition] = this.searchKey
			}

			this.$router.push({ path: this.$route.path, query: params })
		},
		onChangeMode(mode) {
			this.mode = mode
		},
		onCurrentChange(currentPage) {
			console.log('currentPage', currentPage)
			this.getList(currentPage, { total: this.workgroup.total })
		},
		// 获取列表
		getList(pageIndex, _params) {
			this.loading = true
			let params = {
				page: pageIndex,
			}
			if (_params) {
				params = Object.assign({}, params, _params)
			}
			this.$store.dispatch(STORE_CONST.WORKGROUP.LIST_WORKGROUP, params).then(
				(res) => {
					this.loading = false
					this.workgroup = res
					this.loading = false
				},
				() => {
					this.loading = false
				}
			)
		},
		// 获取星标
		getFavourites() {
			let params = {
				page_size: Utils.config.maxPageSize,
				q_favourite: true,
			}
			this.$store.dispatch(STORE_CONST.WORKGROUP.LIST_WORKGROUP, params).then((res) => {
				// this.$store.dispatch(STORE_CONST.WORKGROUP.LIST_FAVOURITE_WORKGROUP, null).then((res) => {
				this.favourites = res.objects
			})
		},
		// set 星标
		setFavourite(row, isFavourite) {
			this.$store
				.dispatch(STORE_CONST.WORKGROUP.SET_FAVOURITE, {
					id: row.id,
					favourite: isFavourite ? 1 : 0,
				})
				.then((res) => {
					let workGroup = null
					if (isFavourite) {
						workGroup = row
						this.favourites = [Object.assign({}, row, { favourite: 1 }), ...this.favourites]
					} else {
						workGroup = this.workgroup.objects.find((item) => {
							return item.id === row.id
						})
						this.favourites.splice(this.favourites.indexOf(row), 1)
						if (!this.favourites || !this.favourites.length) {
							this.mode = 1
						}
					}
					if (workGroup) {
						this.$set(this.workgroup.objects, this.workgroup.objects.indexOf(workGroup), Object.assign({}, workGroup, { favourite: isFavourite ? 1 : 0 }))
					}
				})
		},
		exportExcel(row) {
			window.open(`${baseUrl.apiUrl}/v1/project/resources/${row.id}/export`, '__blank')
		},
	},
	watch: {
		$route(to, from) {
			this.setSearchData()
			this.getList(1, this.$route.query)
		},
	},
}
</script>
<style lang="scss" rel="stylesheet/scss">
.work-group {
	.content {
		padding: 15px;
	}
	.header-nav {
		margin-bottom: 15px;
		.el-input__inner {
			height: 36px;
		}
		.el-button {
			border-radius: 0;
		}
		.search-select {
			float: left;
			width: 100px;
			padding-right: 5px;
		}
		.search-input {
			width: 200px;
			float: left;
			padding-right: 5px;
		}
		.change-view {
			float: right;
			font-size: 20px;
			margin: 7px 10px;
			.active {
				color: #20a0ff;
			}
		}
	}
	a {
		color: #4db3ff;
	}
	.favourites-workgroup {
		.el-icon-star-on {
			color: #ff9900;
			cursor: pointer;
		}
	}
	.list-workgroup {
		margin: 15px 0 0 0;
		.el-icon-star-on {
			cursor: pointer;
			display: none;
			&.default {
				color: #aaa;
			}
			&.active {
				color: #ff9900;
			}
		}
		.export-excel-icon {
			cursor: pointer;
			display: none;
		}
	}
	.el-table__row {
		&:hover {
			cursor: pointer;
			.el-icon-star-on {
				display: block;
			}
			.export-excel-icon {
				display: block;
			}
		}

		.export-excel-icon {
			margin: 4px 0 0 10px;
		}
		.icon-box {
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}
}
</style>



// WEBPACK FOOTER //
// workgroup.vue?fc727cf0